import React from "react";
import ClientProjectsWithTasks from "../../Components/Client/ClientProjectsWithTasks";

const ClientDashboard: React.FC = () => {
  return (
    <div style={{ padding: 20 }}>
  

      {/* ✅ Full table UI with projects, tasks, subtasks */}
      <ClientProjectsWithTasks />
    </div>
  );
};

export default ClientDashboard;
